import { createSlice } from "@reduxjs/toolkit";

const editformslice = createSlice({
  name: "editblog",
  initialState: {
    isEditOpen: false,
  },
  reducers: {
    toogleEdit: (state) => {
      state.isEditOpen = !state.isEditOpen;
    },
  },
});

export const { toogleEdit } = editformslice.actions;
export default editformslice.reducer;